<template>
  <div c_name="IosDownMobile">
    <!--
    <div class="ios_bad" @click="onOpenBad" v-show="!showBad">
      没有掉签却无法安装的玩家<span style="color: #005cf5; padding: 0.6rem 0.4rem;">请点击此处</span>
    </div>
    <div class="ios_bad" v-show="showBad" @click="onCloseBad">
      <span style="color: #005cf5; padding: 0.6rem 0.4rem;">返 回</span>
    </div>
    -->
    <img class="ios_img" :src="showData.iosTips" alt="" v-show="!showBad">
    <img class="ios_img" src="@/assets/ios_bad_install.jpg" alt="" v-show="showBad">
    <div>
      <img class="ios_down" :src="showData.iosPic" alt="" @click="onDown">
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

import tools from '@/tools/tools'

export default {
  name: 'IosDownMobile',
  components: {
  },
  data: () => {
    return {
      isLoadJson: false,
      downType: '',
      showBad: false
    }
  },
  mounted () {
    this.onToTop()
  },
  created () {
    // 加载配置文件，看是要超级签下载，还是正常下载
    this.isLoadJson = false
    this.loadJson()
  },
  methods: {
    loadJson () {
      const self = this
      // json文件url，本地的就写本地的位置，如果是服务器的就写服务器的路径
      const url = '/v.json?v=' + Math.random()
      const request = new XMLHttpRequest()
      // 设置请求方法与路径
      request.open('get', url)
      // 不发送数据到服务器
      request.send(null)
      // XHR对象获取到返回信息后执行
      request.onload = function () {
        let ttype = ''
        // 返回状态为200，即为数据获取成功
        if (request.status === 200) {
          try {
            const json = JSON.parse(request.responseText)
            ttype = json.downType
            self.isLoadJson = true
          } catch (error) {
            console.error('v.json 解析错误')
          }
        }
        // 文件里取出来的值
        self.downType = ttype
      }
    },
    onDown () {
      // const aplusQueue = window.aplus_queue
      // 如果json没有读取到，就刷新一下页面
      if (!this.isLoadJson) {
        // aplusQueue.push({
        //   action: 'aplus.record',
        //   arguments: ['iosDown_vjson_no', 'CLK', { msg: 'json失败' }]
        // })
        console.log('下载方式数据未检测到！')
        location.reload()
        return
      }
      // 超级签下载
      if (this.downType === 'super') {
        // 不知道好使不好使，
        // aplusQueue.push({
        //   action: 'aplus.sendPV',
        //   arguments: [{
        //     is_auto: false
        //   }, {
        //     msg: 'iosDown_super'
        //   }]
        // })
        // aplusQueue.push({
        //   action: 'aplus.record',
        //   arguments: ['iosDown_super', 'CLK', { msg: '超级ios' }]
        // })
        window.open(this.showData.superIpa)
        // 返回上一页
        window.history.back()

        // window.location.href = this.showData.superIpa
      } else {
        // aplusQueue.push({
        //   action: 'aplus.record',
        //   arguments: ['iosDown_normal', 'CLK', { msg: '普通ios' }]
        // })
        tools.iosDoLocation(this.$store.getters.getDownIos(this.downKey))
      }
    },
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    onOpenBad () {
      this.onToTop()
      this.showBad = true
    },
    onCloseBad () {
      this.onToTop()
      this.showBad = false
    }
  },
  computed: {
    downKey () {
      return this.$route.query.id
    },
    showData () {
      return this.$store.state.configs.download[this.downKey]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ios_bad {
  position: fixed;
  background: #f8f8f8;
  top: 3rem;
  left: 0;
  right: 0;
  height: 3rem;
  line-height: 3rem;
  font-weight: bold;
}
.ios_img {
  margin-top: 4rem;
  width: 100%;
}
.ios_down {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
